import { Button } from 'antd';
import imgConfirmacao from '../../assets/img/confirmar/ant-design_question-circle-outlined.svg';
import { useGlobalContext } from '../../context/GlobalContext';
import { IRequestDTO, IRespostaDTO } from '../../models/happy-code-api.model';
import { useAcaRespostaService } from '../../services/aca-resposta';
import { useNotificationService } from '../../services/notification.service';
import './style.css';
import { useUsuarioTrilhaService } from '../../services/usuario-trilha.service';
import { TFunction } from 'i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  alternativas: IRespostaDTO[];
  findResposta: () => void;
  idTrilha: string;
  usuario: any;
  nota: number;
  verificarSeAlunoPassou: () => void;
  t: TFunction<["common", "trilhas"], undefined>
}

export const ModalConfirmacao = (props: Props) => {
  const notification = useNotificationService();
  const { setIsGlobalLoading } = useGlobalContext();
  const respostaService = useAcaRespostaService();
  const { open, onClose, alternativas, findResposta, idTrilha, usuario, nota, verificarSeAlunoPassou } = props;
  const usuarioTrilhaService = useUsuarioTrilhaService();
  const { t } = props


  const create = async () => {
    try {
      await respostaService.saveAll(alternativas);

      notification({
        description: t('trilhas:evaluation.quizSavedSuccess'),
        type: 'success',
        message: t('common:success'),
      });

      findResposta();
    } catch (error) {
      notification({
        description: t('trilhas:evaluation.quizSavedError', { error: error }),
        type: 'error',
        message: t('common:caution'),
      });
    } finally {
      setIsGlobalLoading(false);
      onClose();
      verificarSeAlunoPassou();

    }
  };

  const findStatusAvaliacaoTrilha = async () => {
    setIsGlobalLoading(true)
    const body: IRequestDTO = {
      idTrilha: parseInt(idTrilha),
      idUsuario: usuario?.id,
      nota: nota,
    };
    await usuarioTrilhaService
      .finalizarProva(body)
      .finally(() => {
        create();
      });
  };

  if (!open) return null;

  return (
    <>
      <div className="d-flex-row j-center-a-center modal-container">
        <div className="d-flex-column j-start-a-center modal">
          <div
            className="d-flex-row j-center-a-center circle mb-10"
            style={{ backgroundColor: '#EBEFFC', padding: 16 }}
          >
            <img src={imgConfirmacao} alt="imgConfirmacao" />
          </div>
          <h1 className="mb-10">{t('trilhas:evaluation.confirmModalTitle')}</h1>
          <p>
            {t('trilhas:evaluation.verifyQuestions')}
          </p>
          <div className="line"></div>
          <div className="d-flex-row button-box w-100">
            <Button onClick={props.onClose} className="button-blue mr-5">
              {t('trilhas:evaluation.backAndCheck')}
            </Button>
            <Button onClick={findStatusAvaliacaoTrilha} className="button-primary">
              {t('trilhas:evaluation.finish')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
